module.exports = __webpack_public_path__ + "static/media/mm.8bb35968.png";